import { createStructuredSelector } from 'reselect'

import {
    SECTION_EQUIPMENT_AREA,
    SECTION_EQUIPMENT_AREA_SUCCESS,
    SECTION_EQUIPMENT_AREA_ERROR,
    SECTION_EQUIPMENT_COMPLEXITY,
    SECTION_EQUIPMENT_COMPLEXITY_SUCCESS,
    SECTION_EQUIPMENT_COMPLEXITY_ERROR,
    SECTION_EQUIPMENT_EQUIPMENT,
    SECTION_EQUIPMENT_EQUIPMENT_SUCCESS,
    SECTION_EQUIPMENT_EQUIPMENT_ERROR,
    SECTION_EQUIPMENT_LIST,
    SECTION_EQUIPMENT_LIST_SUCCESS,
    SECTION_EQUIPMENT_LIST_ERROR,
    SECTION_EQUIPMENT_ADD,
    SECTION_EQUIPMENT_ADD_SUCCESS,
    SECTION_EQUIPMENT_ADD_ERROR,
    SECTION_EQUIPMENT_ADD_CHANGE,
    SECTION_EQUIPMENT_EDIT_CHANGE,
    SECTION_EQUIPMENT_UPDATE,
    SECTION_EQUIPMENT_UPDATE_SUCCESS,
    SECTION_EQUIPMENT_UPDATE_ERROR
} from '../../actions';


export const NAME = 'section_equipment';

export const SectionEquipmentArea = (data) => ({
    type: SECTION_EQUIPMENT_AREA,
    payload: data
});

export const SectionEquipmentAreaSuccess = (message) => ({
    type: SECTION_EQUIPMENT_AREA_SUCCESS,
    payload: message
});

export const SectionEquipmentAreaError = (error) => ({
    type: SECTION_EQUIPMENT_AREA_ERROR,
    payload: error
}); 

export const SectionEquipmentComplexity = (data) => ({
    type: SECTION_EQUIPMENT_COMPLEXITY,
    payload: data
});

export const SectionEquipmentComplexitySuccess = (message) => ({
    type: SECTION_EQUIPMENT_COMPLEXITY_SUCCESS,
    payload: message
});

export const SectionEquipmentComplexityError = (error) => ({
    type: SECTION_EQUIPMENT_COMPLEXITY_ERROR,
    payload: error
});

export const SectionEquipmentEquipment = (data) => ({
    type: SECTION_EQUIPMENT_EQUIPMENT,
    payload: data
});

export const SectionEquipmentEquipmentSuccess = (message) => ({
    type: SECTION_EQUIPMENT_EQUIPMENT_SUCCESS,
    payload: message
});

export const SectionEquipmentEquipmentError = (error) => ({
    type: SECTION_EQUIPMENT_EQUIPMENT_ERROR,
    payload: error
});

export const SectionEquipmentList = (page, num_page, orderBy, filters, stateFilter, display) => ({
    type: SECTION_EQUIPMENT_LIST,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter, display: display }
});

export const SectionEquipmentListSuccess = (data) => ({
    type: SECTION_EQUIPMENT_LIST_SUCCESS,
    payload: data
});

export const SectionEquipmentListError = (error) => ({
    type: SECTION_EQUIPMENT_LIST_ERROR,
    payload: error
});

export const SectionEquipmentAdd = (data) => ({
    type: SECTION_EQUIPMENT_ADD,
    payload: data
});

export const SectionEquipmentAddSuccess = (message) => ({
    type: SECTION_EQUIPMENT_ADD_SUCCESS,
    payload: message
});

export const SectionEquipmentAddError = (error) => ({
    type: SECTION_EQUIPMENT_ADD_ERROR,
    payload: error
});

export const SectionEquipmentAddChangeSet = (data) => ({
    type: SECTION_EQUIPMENT_ADD_CHANGE,
    payload: data
});

export const SectionEquipmentEditChangeSet = (data) => ({
    type: SECTION_EQUIPMENT_EDIT_CHANGE,
    payload: data
});

export const SectionEquipmentUpdate = (data) => ({
    type: SECTION_EQUIPMENT_UPDATE,
    payload: data
});

export const SectionEquipmentUpdateSuccess = (message) => ({
    type: SECTION_EQUIPMENT_UPDATE_SUCCESS,
    payload: message
});

export const SectionEquipmentUpdateError = (error) => ({
    type: SECTION_EQUIPMENT_UPDATE_ERROR,
    payload: error
});

const section_equipment = (state) => state[NAME];

export const SectionEquipmentSelector = createStructuredSelector({
    section_equipment
})
